import { useContext, useEffect, useState } from "react";
import { UserContext } from "../components/auth/auth";
import { Limits, VerifyResult, verifyLicense, getPlanExpirationDate } from "@/key";

interface LicenseInfo {
    limits: Limits;
    planExp: number;
    plan: string;
    planId: number;
}

export function useLicense() {
    const user = useContext(UserContext);
    const [licenseInfo, setLicenseInfo] = useState<LicenseInfo | null>(null);
    useEffect(() => {
        const loadLicense = async () => {
            if (!user?.license) {
                setLicenseInfo(null);
                return;
            }

            try {
                const result: VerifyResult = await verifyLicense(user.license);
                console.log('license verify result = ', result);
                if (result.status === "OK" && result.payload) {
                    setLicenseInfo({
                        limits: result.payload.limits,
                        planExp: result.payload.planExp,
                        plan: result.payload.plan,
                        planId: result.payload.planId,
                    });
                } else {
                    setLicenseInfo(null);
                }
            } catch {
                setLicenseInfo(null);
            }
        };

        loadLicense();
    }, [user?.license]);

    const checkLimit = (limitKey: keyof Limits, currentCount: number): boolean => {
        if (!licenseInfo) return true;

        const limitValue = licenseInfo.limits[limitKey];
        if (typeof limitValue === "boolean") {
            return limitValue;
        }
        return currentCount < limitValue;
    };

    const getLimit = (limitKey: keyof Limits): number => {
        if (!licenseInfo) return Infinity;

        const limitValue = licenseInfo.limits[limitKey];
        if (typeof limitValue === "number") {
            return limitValue;
        }
        return Infinity;
    };

    const getExpirationDate = (): Date | null => {
        if (!licenseInfo) return null;
        return getPlanExpirationDate(licenseInfo.planExp);
    };

    return {
        licenseInfo,
        limits: licenseInfo?.limits ?? null,
        checkLimit,
        getLimit,
        getExpirationDate
    };
}
